export const previousStatsNav_style = {
  arrowBtnSx: {
    backgroundColor: '#00000014',
    width: '30px',
    height: '30px',
  },
  planTitle: { fontSize: '16px', fontWeight: 500 },
  PlanstartEndDate: { fontSize: '14px', color: '#5C6066' },
};
